<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'read',
    subject: 'UserGuide',
  },
})

const router = useRouter()

const menuGroups = [
  {
    title: 'Operasional',
    icon: 'ri-shopping-cart-2-line',
    color: 'success',
    items: [
      {
        title: 'POS Kasir',
        route: 'userguide-operasional-pos-kasir',
        description: 'Panduan lengkap kasir dan transaksi',
      },
      {
        title: 'AI Voice Order',
        route: 'userguide-operasional-ai-voice-order',
        description: 'Pesan produk lewat suara — cara pakai & tips akurasi',
      },
      {
        title: 'Penjualan',
        route: 'userguide-operasional-penjualan',
        description: 'Manage order dan shift kasir',
      },
      {
        title: 'Sistem Antrian',
        route: 'userguide-operasional-sistem-antrian',
        description: 'Nomor antrian otomatis, Papan Antrian, dan integrasi Kitchen Display',
      },
    ],
  },
  {
    title: 'Produk & Inventory',
    icon: 'ri-stack-line',
    color: 'info',
    items: [
      {
        title: 'Kategori Produk',
        route: 'userguide-produk-inventory-kategori',
        description: 'Pengelolaan kategori produk',
      },
      {
        title: 'Produk',
        route: 'userguide-produk-inventory-produk',
        description: 'Kelola katalog produk dan variant',
      },
      {
        title: 'Bahan Baku',
        route: 'userguide-produk-inventory-bahan-baku',
        description: 'Manajemen ingredient dan stok',
      },
      {
        title: 'Satuan',
        route: 'userguide-produk-inventory-satuan',
        description: 'Konfigurasi satuan pengukuran',
      },
      {
        title: 'Pergerakan Stok',
        route: 'userguide-produk-inventory-pergerakan-stok',
        description: 'History stock movement',
      },
      {
        title: 'Stock Adjustment',
        route: 'userguide-produk-inventory-stock-adjustment',
        description: 'Penyesuaian stok',
      },
      {
        title: 'Stock Opname',
        route: 'userguide-produk-inventory-stock-opname',
        description: 'Stock opname dan rekonsiliasi',
      },
    ],
  },
  {
    title: 'F&B Modern',
    icon: 'ri-restaurant-2-line',
    color: 'primary',
    route: 'userguide-fb-modern',
    items: [
      {
        title: 'Meja & Area',
        route: 'userguide-fb-modern-tables',
        description: 'Manajemen meja, floor plan, dan area restoran',
      },
      {
        title: 'Tipe Order',
        route: 'userguide-fb-modern-order-type',
        description: 'Dine-in, Takeaway, Delivery, Online Order',
      },
      {
        title: 'Platform Delivery',
        route: 'userguide-fb-modern-delivery-platforms',
        description: 'Integrasi GoFood, GrabFood, ShopeeFood',
      },
      {
        title: 'Stasiun Dapur',
        route: 'userguide-fb-modern-stations',
        description: 'Konfigurasi kitchen stations & routing order',
      },
      {
        title: 'Kitchen Display',
        route: 'userguide-fb-modern-kds',
        description: 'KDS system untuk dapur & bar',
      },
    ],
  },
  {
    title: 'Kasir Lanjutan',
    icon: 'ri-refund-2-line',
    color: 'brown',
    items: [
      {
        title: 'Customer Display System',
        route: 'userguide-kasir-lanjutan-cds',
        description: 'Layar kedua menghadap pelanggan, rincian belanja & kembalian real-time (Premium)',
      },
      {
        title: 'Refund Berotorisasi',
        route: 'userguide-kasir-lanjutan-refund',
        description: 'Kembalikan uang pelanggan untuk transaksi selesai, dengan PIN Manager/Owner',
      },
    ],
  },
  {
    title: 'Fitur Retail',
    icon: 'ri-shopping-bag-3-line',
    color: 'orange',
    route: 'userguide-retail',
    items: [
      {
        title: 'Toggle F&B & Retail',
        route: 'userguide-retail-toggle',
        description: 'Aktifkan Retail berdampingan dengan F&B (hybrid) lewat Pengaturan',
      },
      {
        title: 'Scan Barcode di Kasir',
        route: 'userguide-retail-barcode',
        description: 'Isi barcode produk, scan/ketik + Enter di kasir untuk masuk keranjang',
      },
      {
        title: 'Harga Grosir Bertingkat',
        route: 'userguide-retail-harga-grosir',
        description: 'Harga lebih murah per satuan untuk pembelian dalam jumlah banyak',
      },
      {
        title: 'Tracking Kedaluwarsa',
        route: 'userguide-retail-kedaluwarsa',
        description: 'Catat tanggal kedaluwarsa saat terima barang, pantau lewat laporan',
      },
    ],
  },
  {
    title: 'Marketing & Loyalty',
    icon: 'ri-megaphone-line',
    color: 'pink',
    items: [
      {
        title: 'Promo & Diskon',
        route: 'userguide-promo-voucher-loyalty-promo',
        description: 'Diskon persen/nominal otomatis atau manual',
      },
      {
        title: 'Voucher & Kupon',
        route: 'userguide-promo-voucher-loyalty-voucher',
        description: 'Kode diskon dengan kuota pemakaian',
      },
      {
        title: 'Program Loyalty',
        route: 'userguide-promo-voucher-loyalty-loyalty',
        description: 'Poin & stempel untuk pelanggan setia',
      },
      {
        title: 'Gabungan di 1 Transaksi',
        route: 'userguide-promo-voucher-loyalty-kombinasi',
        description: 'Pakai promo + voucher + poin bersamaan',
      },
    ],
  },
  {
    title: 'CRM & Broadcast Marketing',
    icon: 'ri-customer-service-2-line',
    color: 'deep-purple',
    route: 'userguide-crm-broadcast',
    items: [
      {
        title: 'CRM & Broadcast Marketing',
        route: 'userguide-crm-broadcast',
        description: 'Segmentasi pelanggan, template pesan, & kirim broadcast WhatsApp',
      },
    ],
  },
  {
    title: 'Absensi & Karyawan',
    icon: 'ri-fingerprint-line',
    color: 'teal',
    route: 'userguide-absensi',
    items: [
      {
        title: 'Absensi Karyawan',
        route: 'userguide-absensi',
        description: 'PIN, QR, lokasi toko, kiosk, & laporan kehadiran',
      },
    ],
  },
  {
    title: 'Pembelian',
    icon: 'ri-truck-line',
    color: 'warning',
    route: 'userguide-pembelian',
    items: [
      {
        title: 'Supplier',
        route: 'userguide-pembelian-supplier',
        description: 'Manajemen supplier',
      },
      {
        title: 'Purchase Order',
        route: 'userguide-pembelian-purchase-order',
        description: 'Pembuatan PO',
      },
      {
        title: 'Receiving',
        route: 'userguide-pembelian-receiving',
        description: 'Penerimaan barang',
      },
      {
        title: 'Scan Struk AI',
        route: 'userguide-pembelian-scan-struk-ai',
        description: 'Scan Struk AI',
      },
    ],
  },
  {
    title: 'Keuangan',
    icon: 'ri-money-dollar-circle-line',
    color: 'error',
    route: 'userguide-keuangan',
    items: [
      {
        title: 'Pengeluaran',
        route: 'userguide-keuangan-pengeluaran',
        description: 'Catat pengeluaran operasional',
      },
      {
        title: 'Kategori Pengeluaran',
        route: 'userguide-keuangan-kategori',
        description: 'Kategorisasi expense',
      },
    ],
  },
  {
    title: 'Laporan',
    icon: 'ri-bar-chart-box-line',
    color: 'secondary',
    route: 'userguide-laporan',
    items: [
      {
        title: 'Dashboard Laporan',
        route: 'userguide-laporan-dashboard',
        description: 'Overview laporan bisnis',
      },
      {
        title: 'Laporan Penjualan',
        route: 'userguide-laporan-penjualan',
        description: 'Analisa penjualan',
      },
      {
        title: 'Laporan Inventory',
        route: 'userguide-laporan-inventory',
        description: 'Status stok dan valuasi',
      },
      {
        title: 'Laporan Pembelian',
        route: 'userguide-laporan-pembelian',
        description: 'History pembelian',
      },
      {
        title: 'Laba Rugi',
        route: 'userguide-laporan-laba-rugi',
        description: 'Profit & Loss statement',
      },
    ],
  },
  {
    title: 'Sistem',
    icon: 'ri-settings-3-line',
    color: 'grey',
    route: 'userguide-sistem',
    items: [
      {
        title: 'Foundation & Konfigurasi',
        route: 'userguide-sistem',
        description: 'Multi-tenancy, auth, CASL, tenant isolation',
      },
      {
        title: 'Pengaturan',
        route: 'userguide-sistem-pengaturan',
        description: 'Konfigurasi aplikasi',
      },
      {
        title: 'Printers',
        route: 'userguide-sistem-printers',
        description: 'Setup printer struk, dapur, & label',
      },
      {
        title: 'User & Role',
        route: 'userguide-sistem-user-role',
        description: 'Manajemen user dan permission',
      },
      {
        title: 'Audit Log',
        route: 'userguide-sistem-audit-log',
        description: 'Activity trail sistem',
      },
    ],
  },
]

const searchQuery = ref('')

const filteredMenuGroups = computed(() => {
  if (!searchQuery.value) return menuGroups
  
  const query = searchQuery.value.toLowerCase()
  
  return menuGroups.map(group => ({
    ...group,
    items: group.items.filter(item =>
      item.title.toLowerCase().includes(query) ||
      item.description.toLowerCase().includes(query),
    ),
  })).filter(group => group.items.length > 0)
})
</script>

<template>
  <div>
    <!-- Header -->
    <VRow>
      <VCol cols="12">
        <h4 class="text-h4 font-weight-bold mb-2">
          📚 User Guide PintuKasir
        </h4>
        <p class="text-body-1 text-medium-emphasis mb-6">
          Dokumentasi lengkap penggunaan semua fitur dan modul PintuKasir
        </p>
      </VCol>
    </VRow>

    <!-- Search -->
    <VRow>
      <VCol
        cols="12"
        md="6"
      >
        <VTextField
          v-model="searchQuery"
          placeholder="Cari panduan (contoh: POS, produk, stok, printer...)"
          prepend-inner-icon="ri-search-line"
          clearable
          hide-details
        />
      </VCol>
    </VRow>

    <!-- Menu Groups -->
    <VRow class="mt-4">
      <VCol
        v-for="group in filteredMenuGroups"
        :key="group.title"
        cols="12"
        md="6"
        lg="4"
        class="mb-6"
      >
        <VCard
          variant="outlined"
          class="h-100 guide-card"
        >
          <VCardText>
            <RouterLink
              v-if="group.route"
              :to="{ name: group.route }"
              class="text-decoration-none"
            >
              <div class="d-flex align-center mb-4 guide-group-header">
                <VAvatar
                  :color="group.color"
                  variant="tonal"
                  size="48"
                  class="me-3"
                >
                  <VIcon
                    :icon="group.icon"
                    size="28"
                  />
                </VAvatar>
                <div>
                  <h6 class="text-h6 font-weight-bold mb-0 text-high-emphasis">
                    {{ group.title }}
                    <VIcon
                      icon="ri-arrow-right-s-line"
                      size="18"
                      class="ms-1"
                    />
                  </h6>
                  <div class="text-xs text-disabled">
                    {{ group.items.length }} panduan
                  </div>
                </div>
              </div>
            </RouterLink>

            <div
              v-else
              class="d-flex align-center mb-4"
            >
              <VAvatar
                :color="group.color"
                variant="tonal"
                size="48"
                class="me-3"
              >
                <VIcon
                  :icon="group.icon"
                  size="28"
                />
              </VAvatar>
              <div>
                <h6 class="text-h6 font-weight-bold mb-0">
                  {{ group.title }}
                </h6>
                <div class="text-xs text-disabled">
                  {{ group.items.length }} panduan
                </div>
              </div>
            </div>

            <VDivider class="mb-3" />

            <VList
              density="compact"
              class="guide-list"
            >
              <VListItem
                v-for="item in group.items"
                :key="item.title"
                :to="{ name: item.route }"
                class="guide-item mb-1"
                rounded="lg"
              >
                <VListItemTitle class="text-body-2 font-weight-medium">
                  {{ item.title }}
                </VListItemTitle>
                <VListItemSubtitle class="text-xs mt-1">
                  {{ item.description }}
                </VListItemSubtitle>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Quick Stats -->
    <VRow class="mt-6">
      <VCol cols="12">
        <VCard
          color="primary"
          variant="tonal"
        >
          <VCardText>
            <div class="d-flex align-center justify-space-between flex-wrap gap-4">
              <div>
                <h6 class="text-h6 mb-1">
                  📖 Total Panduan
                </h6>
                <p class="text-body-2 mb-0">
                  {{ menuGroups.reduce((acc, group) => acc + group.items.length, 0) }} topik tersedia
                </p>
              </div>
              <VChip
                color="primary"
                size="large"
              >
                {{ menuGroups.length }} Kategori
              </VChip>
            </div>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>

<style lang="scss" scoped>
.guide-group-header {
  transition: opacity 0.15s ease;
}
.guide-group-header:hover {
  opacity: 0.75;
}

.guide-card {
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(var(--v-theme-primary), 0.5) !important;
  }
}

.guide-item {
  transition: all 0.2s ease;

  &:hover {
    background: rgba(var(--v-theme-primary), 0.08);
  }
}
</style>
